import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CodeInputModule } from 'angular-code-input';

@Component({
  selector: 'app-register-pin-step',
  templateUrl: './register-pin-step.component.html',
  styleUrls: ['./register-pin-step.component.scss'],
  imports: [TranslatePipe, CodeInputModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class RegisterPinStepComponent {
  public pinSubmit = output<string>();
  public back = output<void>();

  public passcodeValue = signal({
    passcode: '',
    confirmPasscode: '',
    valid: false,
  });

  public enterPasscode(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      passcode: password,
      valid: password === value.confirmPasscode,
    }));
  }

  public enterConfirmPasscode(password: string): void {
    this.passcodeValue.update((value) => ({
      ...value,
      confirmPasscode: password,
      valid: value.passcode === password,
    }));
  }

  public createAccount(): void {
    this.pinSubmit.emit(this.passcodeValue().passcode);
  }
}
